import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  VStack,
  Wrap,
  WrapItem,
} from "@chakra-ui/react";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import blogMaskBackImg from "../../assets/img-blog-mask-back.svg";
import frontImg from "../../assets/img-mask-front.svg";
import maskImg from "../../assets/img-mask.svg";
import useSite from "../../hooks/use-site";
import { wpStyles } from "../../theme/wp-styles";

const PageBannerBlog = () => {
  const site = useSite();
  const title = site[site.postType]?.title;

  return (
    <Box
      py={{
        base: 8,
        md: 16,
        lg: 20,
      }}
      borderTop="1px"
      borderBottom="1px"
      bg="green.400"
      borderColor={wpStyles.colors.border}
      mb={32}
    >
      <Container>
        <Flex>
          <VStack align="stretch" spacing={4}>
            <Heading
              fontSize={{
                base: wpStyles.fontSize.xl,
                md: wpStyles.fontSize.xl,
                lg: wpStyles.fontSize.colossal,
              }}
              as="h1"
              mb="0"
              color="white"
              fontWeight="bold"
            >
              AWA Blog
            </Heading>
            <BlogCategories />
          </VStack>
          <Box position="relative" flex="1">
            <BlogMaskedImage />
          </Box>
        </Flex>
      </Container>
    </Box>
  );
};

const BlogCategories = () => {
  const site = useSite();

  const categories = site?.categories?.nodes || [];

  return (
    <Wrap maxW="600px">
      <WrapItem>
        <BlogCategoryButton
          category={{ id: "all", slug: "/resources", name: "All Blogs" }}
        />
      </WrapItem>
      {categories.map((category) => (
        <WrapItem key={category.id}>
          <BlogCategoryButton category={category} />
        </WrapItem>
      ))}
    </Wrap>
  );
};

const BlogCategoryButton = ({ category }) => {
  // Get current URL
  const router = useRouter();
  let isActive = router.asPath === `/resources/category/${category?.slug}/`;

  let url = `/resources/category/${category?.slug}`;

  if (category?.slug === "/resources") {
    url = "/resources";
    if (router.asPath === "/resources/") {
      isActive = true;
    }
  }

  return (
    <Link key={category?.id} href={url} passHref legacyBehavior>
      <Button
        as="a"
        color={isActive ? "green.500" : "white"}
        py={6}
        whiteSpace="nowrap"
        fontSize="sm"
        border="none"
        borderRadius="md"
        bg={isActive ? "white" : "rgba(0, 0, 0, 0.4)"}
      >
        {category?.name}
      </Button>
    </Link>
  );
};

const BlogMaskedImage = () => {
  return (
    <Box
      position="absolute"
      sx={{
        ".masked": {
          rounded: "lg",
          maskImage: `url('${maskImg.src}')`,
        },
      }}
      right="0"
      top="-80px"
      display={{ base: "none", lg: "block" }}
    >
      {/* <pre>{JSON.stringify(img, 0, 2)}</pre> */}
      <Box
        position="absolute"
        top={{
          base: "-10px",
          lg: "0px",
        }}
        left={{
          base: "-10px",
          lg: "0",
        }}
        opacity="1"
        maxW={{ base: "80%", lg: "100%" }}
      >
        <Image
          src={blogMaskBackImg.src}
          width={350}
          height={350}
          className="mask-back"
          alt="Masking Image Back"
        />
      </Box>
      <img
        src="https://mu.staging.premierhsllc.com/wp-content/uploads/sites/2/AWA-Health-Care-Discounts.jpg"
        alt="AWA Health Care Discounts"
        width={`452px`}
        height={`452px`}
        className="masked"
      />
      <Box
        position="absolute"
        bottom={{ base: "-30px", lg: "10px" }}
        right={{ base: "0px", lg: "100px" }}
        opacity="0.8"
        maxW={{ base: "40%", lg: "100%" }}
      >
        <img
          src={frontImg.src}
          width={"150px"}
          height={"150px"}
          className="mask-front"
          alt="Masking Image Front"
        />
      </Box>
    </Box>
  );
};

export default PageBannerBlog;
